import {createApp} from 'vue'
import Store from 'store'
import FilterComponent from './FilterComponent'

const component = createApp(FilterComponent).use(Store)

const el = '.nlx-component--filter-component'
const DOM = document.querySelector(el)

if(DOM){
    component.mount(el)
}

